"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";

import { cn } from "@/lib/utils";
import { LuCheck } from "react-icons/lu";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      "peer h-[14px] w-[14px] shrink-0 rounded-sm squircle squircle-radius-[4px] squircle-smooth-[1] squircle-outline-[1px] squircle-fill-border-gray ring-offset-background focus-visible:outline-none  disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:squircle-fill-brand-orange data-[state=checked]:squircle-mask data-[state=checked]:text-primary-foreground",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <LuCheck className="h-[85%] w-[85%]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
